export function getComplaintTypesData(snapshots, sector) {
  if (sector === "all") {
    return getComplaintsByMonth(snapshots);
  }
  let complaintTypes = [];
  let totalTickets = [];
  let closedTickets = [];

  let newArray = snapshots;
  let tempData = newArray.filter((complaint) => {
    let data = complaint.val();
    if (data.sectors && data.sectors.includes(sector.toLowerCase())) {
      return data;
    }
  });

  tempData.forEach((complaint) => {
    if (
      complaint.val().complaintType === "empty" ||
      !complaint.val().complaintType
    ) {
      return;
    }
    if (complaintTypes.indexOf(complaint.val().complaintType) === -1) {
      complaintTypes.push(complaint.val().complaintType);
    }

    const index = complaintTypes.indexOf(complaint.val().complaintType);

    if (!totalTickets[index]) {
      totalTickets[index] = 0;
      closedTickets[index] = 0;
    }

    totalTickets[index] += 1;

    if (complaint.val().status === "closed") {
      closedTickets[index] += 1;
    }
  });

  return {
    categories: complaintTypes,
    data: tempData,
    series: [
      {
        data: totalTickets,
        name: "Total",
      },
      {
        data: closedTickets,
        name: "Closed",
      },
    ],
  };
}

function getComplaintsByMonth(snapshots) {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthPayload = [];
  const closedTickets = [];
  const cancelledTickets = [];
  const pendingTickets = [];

  for (let index = 0; index < monthNames.length; index++) {
    const value = snapshots.filter((doc) => {
      let date = new Date(doc.val().created);
      const month = date.getMonth();

      if (month === index) {
        return doc;
      }
    }).length;

    const closed = snapshots.filter((doc) => {
      let date = new Date(doc.val().created);
      const month = date.getMonth();

      if (month === index && doc.val().status === "closed") {
        return doc;
      }
    }).length;
    const pending = snapshots.filter((doc) => {
      let date = new Date(doc.val().created);
      const month = date.getMonth();

      if (month === index && doc.val().status === "processing") {
        return doc;
      }
    }).length;

    const cancelled = snapshots.filter((doc) => {
      let date = new Date(doc.val().created);
      const month = date.getMonth();

      if (month === index && doc.val().status === "cancelled") {
        return doc;
      }
    }).length;

    monthPayload.push(value);
    closedTickets.push(closed);
    pendingTickets.push(pending);
    cancelledTickets.push(cancelled);
  }

  let categories = monthNames;
  let series = [
    { data: monthPayload, name: "Total" },
    { data: closedTickets, name: "Closed" },
    {
      data: pendingTickets,
      name: "Processing",
    },
    {
      data: cancelledTickets,
      name: "Cancelled",
    },
  ];

  return {
    categories,
    series,
  };
}

export function getAgeGroupData(snapshots, sector) {
  let ageGroups = [];
  let payload = [];
  let newArray = snapshots;

  let tempData = newArray.filter((complaint) => {
    let data = complaint.val();
    if (
      data.sectors &&
      data.sectors.includes(sector.toLowerCase()) &&
      data.status !== "cancelled"
    ) {
      return data;
    }
  });

  tempData.forEach((complaint) => {
    if (ageGroups.indexOf(complaint.val().ageGroup) === -1) {
      ageGroups.push(complaint.val().ageGroup);
    }

    const index = ageGroups.indexOf(complaint.val().ageGroup);

    if (!payload[index]) {
      payload[index] = 0;
    }

    payload[index] += 1;
  });

  return {
    categories: ageGroups,
    data: tempData,
    series: payload,
  };
}
